<template>
  <div
    class="layer-button"
    @click="showVisualizationPanel"
  >
    <img
      width="140px"
      height="140px"
      src="~@/assets/images/btn-show-visualization.svg"
      alt="詳細情報を表示"
    >
  </div>
</template>

<script>
export default {
  methods: {
    showVisualizationPanel() {
      this.$store.commit('map/toggleVisualizationPanel', true);
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// button.vue?f7b7f3ec